import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 销售内勤
 * 查询
 * @param {*} params
 */
export function assginSaleCenter(data) {
  return request({
    url: BASE_API() + '/staff/addSaleCenter',
    method: 'post',
    data
  })
}


export function loadChargeSaleCenter(data) {
  return request({
    url: BASE_API() + '/staff/loadSetting',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/applyForGoods/staff.js